namespace $.$$ {
	export class $shm_hitalama_map_widget_float_chrome_telegram extends $.$shm_hitalama_map_widget_float_chrome_telegram {
		
		rpc_listener() {
			const rpc = new $mol_rpc_server()
			const handlers = {
				id: ( id: string )=> {
					this.chat_id( id )
				}
			}
			rpc.handlers = ()=> handlers
			return rpc.listener()
		}

		@ $mol_mem_key
		Content_by_type( name: string ): Record< ReturnType< $shm_hitalama_map_widget_float_form_custom['field_type'] >, any > {
			return this.Content_by_type_override( name )
		}

		require_id(){
			window.parent.postMessage( { name: 'id' }, '*')
		}

		@ $mol_mem
		chat_id( next?: string ) {
			return next ?? ''
		}

		field_names() {
			return [ this.chat_id() ]
		}

		field_type( id: string ) {
			return 'any'
		}
		
	}
}
